import React from 'react';
import PropTypes from 'prop-types';
import IconExclamationCircle from '@spothero/icons/exclamation-circle';
import Modal from '@spothero/ui/modal';
import ModalContent from '@spothero/ui/modal-content';
import TextButton from '@spothero/ui/text-button';

const NoResultsModal = ({
    isMobile,
    isFiltered,
    onFilterResults,
    onResetFilters,
    onHidden,
}) => {
    return (
        <Modal
            className="NoResultsModal"
            renderInBody={isMobile}
            title="No Spots Found"
            onHidden={onHidden}
        >
            <ModalContent>
                {isFiltered ? (
                    <>
                        <h3>
                            <IconExclamationCircle className="exclamation-circle" />
                            <span className="NoResultsModal-subheader-text">
                                Looks like you&apos;ve filtered yourself out of
                                spots!
                            </span>
                        </h3>
                        <div>
                            <p>
                                If these are criteria you can live
                                without,&nbsp;
                                <TextButton onClick={onFilterResults}>
                                    Select Fewer Filters
                                </TextButton>
                                &nbsp;or&nbsp;
                                <TextButton onClick={onResetFilters}>
                                    Reset Filters
                                </TextButton>
                                .
                            </p>
                            <p>
                                Or, adjust your entry or exit times by an hour
                                or two.
                            </p>
                        </div>
                    </>
                ) : (
                    <p>
                        We couldn&apos;t find any parking matching your search.
                        Try changing your search location or reservation times.
                    </p>
                )}
            </ModalContent>
        </Modal>
    );
};

NoResultsModal.propTypes = {
    isMobile: PropTypes.bool.isRequired,
    isFiltered: PropTypes.bool,
    onFilterResults: PropTypes.func.isRequired,
    onResetFilters: PropTypes.func.isRequired,
    onHidden: PropTypes.func.isRequired,
};

export default NoResultsModal;
